import { useForceResetPasswordPage } from "./logic";
import { ForceResetPasswordPageTemplate } from "./template";

export const ForceResetPasswordPage = (): JSX.Element => {
  const data = useForceResetPasswordPage();
  return <ForceResetPasswordPageTemplate {...data} />;
};
